module.exports = __webpack_public_path__ + "media/error01.e7e21130.mp3";